import { IMedia } from '@/admin/helpers/interfaces/media-types';
import { IComponent } from '@/admin/helpers/interfaces/component-types'
import { addProps, deleteNestedItem, findNestedItem } from '@/helpers/helpers'
import { createModel } from '@rematch/core'
import { gallery,getMedia,savemedia,getMediaByUrl,getmedia,getPagenation,editmedia,deletedmedia } from '../../../services/mediaService';
const initialState: { page: string, editMode: boolean,  pages:IMedia[], isloaded: boolean,pagesp:any } = {
	isloaded: false,
	editMode: false,
    page: "Media",
    pages:[],
    pagesp:[]
}
export const mediaModel = createModel()({
    state: { ...initialState },
    reducers: {

        setMedia(state, payload) {
            return {
                ...state,
                page: payload.page,
            }
        },

        setMode(state, payload) {
            return {
                ...state,
                editMode: payload.editMode,
            }
        },
		setIsLoading(state, payload){

            return {
                ...state,
                isloaded: payload

            }
        },
		setMedias(state, payload) {
            return {
                ...state,
                pages: payload.data,
            }
        },
		addMedias(state, payload) {
            return {
                ...state,
                pages: [...state.pages, payload],
            }
        },
		setMediasPage(state, payload) {
            return {
                ...state,
                pagesp: [...state.pagesp, payload],
            }
        },


    },
	effects: (dispatch) => ({

        
        async getPagesAsync() {
			const responses = await gallery();
			console.log(responses);
			if (responses) { 
			 const response = await getMedia(responses);
			 console.log(responses)
			 response.id_gal =responses;

			if (response) { 
			   this.setMedias({ data: response.data.photos })

				return response
			} else {
				this.setMedias({ data: [] })
                return {}
			}
		}

		},
		async getPagenationAsync() {
			const response = await getPagenation();
			if (response) { 
				this.setMediasPage({ data: response })
 
				 return response
			 } else {
				 this.setMediasPage({ data: [] })
				 return {}
			 }

		},

        
		async addPagesAsync(payload, rootState) {
			let response = await savemedia(payload);
			if (response) {
			
	
				return response


			} else {
				console.log("else")

			}

		},

        async editPagesAsync(payload, rootState) {
			let response = await editmedia(payload);
			if (response) {
				console.log(payload)
				console.log(response)
				return response


			} else {
				console.log("else")

			}

		},


        async deletedPagesAsync(payload, rootState) {
          
			let response = await deletedmedia(payload);
			if (response) {
				
				return response


			} else {
				console.log("else")

			}

		},
        
	}),
})